<template>
  <v-card>
    <v-card-title
      class="headline"
      primary-title>
      Create New Bot
    </v-card-title>
    <v-card-text>
      <v-text-field
        outline
        v-model="addObj.name"
        placeholder="Bot Name"
        type="text"
        flat
      ></v-text-field>
      <image-input
              :url="addObj.image"
              @onImageUpload="updateImageUrl"/>
    </v-card-text>
    <v-divider/>
    <v-card-actions>
      <v-spacer/>
      <v-btn
        :disabled="!addObj.name.trim().length"
        :loading = "addButtonLoader"
        color="primary"
        @click="addBot">
        Create
      </v-btn>
      <v-btn
        outline
        @click="$emit('closeDialog')">
        close
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import common from "../../utils/common";
  import imageInput from '../block-build/blocks/block-cards/common-inner-blocks/image-uploader-dropzone'
  export default {
    name: "botAddDialog",
    components: {
      imageInput
    },
    data(){
      return {
        addObj:{
          name: '',
          image: ''
        },
        addButtonLoader: false
      }
    },
    methods: {
      addBot() {
        this.addButtonLoader = true
        this.$http.post(`/users/bot`,this.addObj)
        .then(response=>{
          this.addButtonLoader = false
          this.addObj.name = ''
          this.addObj.image = ''
          this.$emit('closeDialog')
          this.$emit('reloadBots')
          setTimeout(()=>{
            window.scrollTo(0,document.body.scrollHeight)
          },2000)
        })
        .catch(error=>{
          this.addButtonLoader = false
          if (error.response && error.response.status === 401) {
            common.logOut()
          } else {
            this.$store.dispatch('setErrorMessage', true)
          }
        })
      },
      updateImageUrl(e) {
        this.addObj.image = e
      }
    }
  }
</script>

<style scoped>

</style>
